import * as React from 'react';
import {observer} from 'mobx-react';
import {styled} from '../../utils';
import AirbnbCodeVerificationForm from './private/AirbnbCodeVerificationForm';
import AirbnbCodeRequestButton from './private/AirbnbCodeRequestButton';
import {AirbnbCodeVerification} from '../../models/airbnbAuthModel';

export interface AirbnbCodeVerificationProcedureProps {
  method: AirbnbCodeVerification;
}

const Description = styled('h5')({
  fontWeight: 700,
  marginBottom: 15
});

@observer
export default class AirbnbCodeVerificationProcedure extends React.Component<AirbnbCodeVerificationProcedureProps, {}> {
  public render() {
    const {method} = this.props;
    const {hintText: description, isSelected} = method;

    return (
      <div style={{paddingBottom: 20}}>
        <Description>{description}</Description>
        {isSelected ? <AirbnbCodeVerificationForm method={method} /> : <AirbnbCodeRequestButton method={method} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/AirbnbCodeVerificationProcedure/AirbnbCodeVerificationProcedure.tsx